// Standard e-postvalidering
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Interne ansatte-domener som aldri kan være sluttbrukere. Blokkerer eksakt domene og alle
// subdomener (f.eks. foo.miljodir.no). Speiler backend (ExternalUserService._blockedDomains).
// Fødererte domener (statsforvalteren/fylkesmannen) blokkeres IKKE her – de kan tildeles rolle
// hvis brukeren finnes fra før, og avvises av backend ved forsøk på nyoppretting.
export const blockedEmailDomainPattern = /@([\w-]+\.)*(miljodir|miljodirektoratet)\.no$/i;

// Fødererte domener. Vises som melding i skjemaet, men blokkerer ikke innsending, siden
// eksisterende brukere fortsatt kan tildeles rolle. Speiler ExternalUserService._creationBlockedFederatedDomains.
export const federatedEmailDomainPattern = /@([\w-]+\.)*(statsforvalteren|fylkesmannen)\.no$/i;

export function isBlockedEmailDomain(email: string): boolean {
  return blockedEmailDomainPattern.test(email);
}
